import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { IoIosFootball } from "react-icons/io";
import { FaBasketballBall } from "react-icons/fa";
import { GiSoccerBall } from "react-icons/gi";

const Sports = () => {
  const constainerVariant = {
    hidden: {
      x: "-100vw",
    },
    visible: {
      x: 0,
      transition: { delay: 0.5, type: "spring", stiffness: 50 },
    },
    exit: {
      opacity: 0,
      transition: { ease: "easeInOut" },
    },
  };

  return (
    <>
      <Container
        variants={constainerVariant}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <p>
          I am a major football enthusiast. I'm either watching or playing
          semi-pro football, primarily in the center forward position, which I
          prefer.
        </p>
        <div className="cube-container">
          <div className="stage-cube">
            <div className="cubespinner">
              <div className="face1">
                <MyIoIosFootball />
              </div>
              <div className="face2">
                <MyFaBasketballBall />
              </div>
              <div className="face3">
                <MyGiSoccerBall />
              </div>
              <div className="face4">
                <MyIoIosFootball />
              </div>
              <div className="face5">
                <MyFaBasketballBall />
              </div>
              <div className="face6">
                <MyGiSoccerBall />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Sports;

const Container = styled(motion.div)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 2rem;
  gap: 1rem;

  :hover {
  }

  p {
    font-size: 22px;
    flex: 1;
    display: inline-block;
    text-align: justify;
    width: 100%;
  }

  .cube-container {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .stage-cube {
      width: 80%;
      height: 80%;
      left: 0;
      bottom: 0;
      padding-top: 18%;
      margin-left: 0;
      overflow: hidden;
      position: absolute;
    }

    .cubespinner {
      animation-name: spincube;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-duration: 12s;
      transform-style: preserve-3d;
      transform-origin: 100px 100px 0;
      margin-left: calc(50% - 100px);

      div {
        position: absolute;
        width: 200px;
        height: 200px;
        border: 1px solid #ccc;
        background: rgba(255, 255, 255, 0.4);
        font-size: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 20px 0px ${(props) => props.theme.dark.neutral};
      }

      .face1 {
        transform: translateZ(100px);
      }
      .face2 {
        transform: rotateY(90deg) translateZ(100px);
      }
      .face3 {
        transform: rotateY(90deg) rotateX(90deg) translateZ(100px);
      }
      .face4 {
        transform: rotateY(180deg) rotateZ(90deg) translateZ(100px);
      }
      .face5 {
        transform: rotateY(-90deg) rotateZ(90deg) translateZ(100px);
      }
      .face6 {
        transform: rotateX(-90deg) translateZ(100px);
      }
    }

    @keyframes spincube {
      from,
      to {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg);
      }
      16% {
        transform: rotateY(-90deg);
      }
      33% {
        transform: rotateY(-90deg) rotateZ(90deg);
      }
      50% {
        transform: rotateY(-180deg) rotateZ(90deg);
      }
      66% {
        transform: rotateY(-270deg) rotateZ(90deg);
      }
      83% {
        transform: rotateX(90deg);
      }
    }
  }

  @media screen and (max-width: 760px) {
    display: block;
    margin: auto;

    p {
      font-size: 18px;
      margin-right: 1rem;
      text-align: left;
      width: 100%;
      margin-bottom: 2rem;
    }

    .cube-container {
      width: 100%;
      height: 300px;
      object-fit: cover;
      flex: 1;
    }
  }
`;

const MyIoIosFootball = styled(IoIosFootball)`
  color: ${(props) => props.theme.dark.text};

  /* @media (prefers-color-scheme: light) {
    color: ${(props) => props.theme.dark.primary};
  } */
`;

const MyFaBasketballBall = styled(FaBasketballBall)`
  color: ${(props) => props.theme.dark.text};

  /* @media (prefers-color-scheme: light) {
    color: ${(props) => props.theme.dark.primary};
  } */
`;
const MyGiSoccerBall = styled(GiSoccerBall)`
  color: ${(props) => props.theme.dark.text};

  /* @media (prefers-color-scheme: light) {
    color: ${(props) => props.theme.dark.primary};
  } */
`;
